var path = '/glow/component/glow-vote/tpl/vote-modal.html';
var html = "<div class=\"modal-body vote-modal\"> <h1 id=modal-title class=screen-reader-content>Vote</h1> <ng-include src=\"'/common/formly/formly.tpl.html'\"></ng-include> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-vote/tpl/vote-modal.html
// module id = 1712
// module chunks = 1